export default {
  apiBaseUrl: 'https://mommyki.com.ph/api/v1/',
  accessTokenKey: 'Authorization',
  bearerPrefix: 'bearer',
  accessDeniedPath: '/access-denied',
  expires: 365,
  secure: false
};
// export default {
//   apiBaseUrl: 'http://192.168.2.104:3000/api/v1/',
//   accessTokenKey: 'Authorization',
//   bearerPrefix: 'bearer',
//   accessDeniedPath: '/access-denied',
//   expires: 365,
//   secure: false
// };
